/*
 *  (c) 2015 - 2025 ENISCO by FORCAM GmbH
 */

import {useSelector} from 'react-redux'
import {AppRootState} from '../model/config'

const useProfileNotificationPosition = () => {
  const value = useSelector((state: AppRootState) => state.app.profile?.notification_position) ?? 'top-right'

  return [value]
}

export default useProfileNotificationPosition
